import { Component, OnInit } from '@angular/core';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import anime from 'animejs/lib/anime.es.js';


@Component({
  selector: 'app-technology',
  templateUrl: './technology.component.html',
  styleUrls: ['./technology.component.scss']
})
export class TechnologyComponent implements OnInit {
  baseUrl = 'https://minio.macroad.co.id/weave/';

  constructor() { }

  ngOnInit(): void {
    // gsap.registerPlugin(ScrollTrigger);
    // gsap.set(".tech-title, .ct_1, .ct_2, .ct_3", {
    //   opacity: -0.4
    // });
  }

  ngAfterViewInit(): void {

    // gsap.to(".tech-title", {
    //   opacity: 1,
    //   duration: 1.5,
    //   scrollTrigger:{
    //     trigger: ".tech-title",
    //     start: "-60% 80%",
    //     end: "-60% 80%",
    //     scrub: 1,
    //     toggleActions:"restart complete none reverse",
    //     onEnter: this.techFunc,
    //     // markers: true,
    //   }
    // });
    // gsap.to(".ct_1", {
    //   opacity: 1,
    //   duration: 1.5,
    //   scrollTrigger:{
    //     trigger: ".ct_1",
    //     start: "-40% 80%", 
    //     end: "-40% 80%",
    //     scrub: 1,
    //     toggleActions:"restart complete none reverse",
    //     onEnter: this.ct1Func,
    //     // markers: true,
    //   }
    // });
    // gsap.to(".ct_2", {
    //   opacity: 1,
    //   duration: 1.5,
    //   scrollTrigger:{
    //     trigger: ".ct_2",
    //     start: "top 80%",
    //     end: "top 80%",
    //     scrub: 1,
    //     toggleActions:"restart complete none reverse",
    //     // markers: true,
    //     onEnter: () =>{
    //       this.ct2Func()
    //       ScrollTrigger.refresh(true);
    //     } 
    //   }
    // });
    // gsap.to(".ct_3", {
    //   opacity: 1,
    //   duration: 1.5,
    //   scrollTrigger:{
    //     trigger: ".ct_3",
    //     start: "top 80%",
    //     end: "top 80%", 
    //     scrub: 1,
    //     toggleActions:"restart complete none reverse",
    //     // markers: true,
    //     onEnter: () =>{
    //       this.ct3Func()
    //       ScrollTrigger.refresh(true);
    //     } 
    //   }
    // });
  }

  techFunc(){
    anime.timeline({loop: false})
    .add({
      targets: '.tech-title .text-wrapper',
      translateY: [100, 0],
      easing: 'easeOutExpo',
      duration: 2000,
    })
  }

  ct1Func(){
    anime.timeline({loop: false})
    .add({
      targets: '.ct_1 .text-wrapper',
      translateY: [100, 0],
      easing: 'easeOutExpo',
      duration: 2000,
    });
  }

  ct2Func(){
    anime.timeline({loop: false})
    .add({
      targets: '.ct_2 .text-wrapper',
      translateY: [100, 0],
      easing: 'easeOutExpo',
      duration: 2000,
    });
  }

  ct3Func(){
    anime.timeline({loop: false})
    .add({
      targets: '.ct_3 .text-wrapper',
      translateY: [100, 0],
      easing: 'easeOutExpo',
      duration: 2000,
    });
  }


}
